const deepCopy = <T>(obj: T): T => {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  if (Array.isArray(obj)) {
    const arrCopy = [] as any[];
    obj.forEach((item, index) => {
      arrCopy[index] = deepCopy(item);
    });
    return arrCopy as any;
  }

  const objCopy = {} as { [key: string]: any };
  Object.keys(obj).forEach((key) => {
    objCopy[key] = deepCopy((obj as { [key: string]: any })[key]);
  });

  return objCopy as T;
};

export default deepCopy;